// extracted by mini-css-extract-plugin
export var coverTimeOfDay = "style-module--cover-time-of-day--dytaH";
export var morning = "style-module--morning--VatmW";
export var afternoon = "style-module--afternoon--uTaEH";
export var evening = "style-module--evening--AmG9e";
export var night = "style-module--night--IOD7c";